<template>
  <ul class="navbar-nav">

    <li v-for="(itemMenuSettings, index) in menuSettings"
        :key="index"
        class="nav-item scc-nav-item top-nav-item"
    >
      <router-link
          v-if="itemMenuSettings.banner !== 'Questionnaire' || (itemMenuSettings.banner === 'Questionnaire' && itemMenuSettings.href === '/login-donor')"
          :to="{ name: itemMenuSettings.name } "
          class="nav-link hover-item-a"
      >
        {{itemMenuSettings.banner}}
      </router-link>
      <a
          v-else
          :href="itemMenuSettings.href"
          class="nav-link hover-item-a"
          target="_blank"
      >
        {{itemMenuSettings.banner}}
      </a>
    </li>

  </ul>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "topNavMenu",
  data(){
    return {
      menuSettings: {
        home: {
          name: 'home',
          banner: 'Home',
          href: '/'
        },
        donateBlood: {
          name: 'donateBlood',
          banner: 'Donate Blood',
          href: '/donate-blood'
        },
        myDonations: {
          name: 'myDonations',
          banner: 'Appointments',
          href: '/my-donations'
        },
        previousDonations: {
          name: 'previousDonations',
          banner: 'Previous Donations',
          href: '/previous-donations'
        },
/*        rewardsStore: {
          name: 'rewardsStore',
          banner: 'Rewards',
          href: '/rewards-store',
        },*/
        questionnaire: {
          name: 'loginDonor',
          banner: 'Questionnaire',
          href: '/login-donor',
        },
        contactUs: {
          name: 'contactUs',
          banner: 'Contact Us',
          questionnaire: '/contact-us',
        },
      },
    }
  },
  computed : {
    ...mapState({
      authDonor: state => state.auth.authDonor,
      typeLoginDhq: state => state.settingsAndCustomize.donorPortalSettings.dhq.enable,
      linkDhqPage: state => state.settingsAndCustomize.donorPortalSettings.dhq.location,
    })
  },
  created () {
    switch(true) {
      case !this.typeLoginDhq && this.linkDhqPage === '':
        delete this.menuSettings.questionnaire
        break
      case !this.typeLoginDhq && this.linkDhqPage !== '':
        this.menuSettings.questionnaire.href = this.linkDhqPage
        break
      case this.typeLoginDhq && this.authDonor:
        this.menuSettings.questionnaire.href = this.linkDhqPage
        break
      case this.typeLoginDhq && !this.authDonor:
        this.menuSettings.questionnaire.href = '/login-donor'
        break
    }
  },
}
</script>

<style scoped>
.navbar-nav .scc-nav-item a {
  display: inline-block;
  font-size: 15px;
  color: var(--BasicFontColor);
  text-decoration: none;
  margin: 0 0 0 5px;
  position: relative;
  padding: 0;
}
.navbar-nav .scc-nav-item a:hover {
  color: var(--ButtonColor);
}


.top-nav-item{
  margin-left: 40px;
}

.hover-item-a:before {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  -webkit-transform: scaleX(0);
  -ms-transform: scaleX(0);
  transform: scaleX(0);
  height: .125rem;
  bottom: .125rem;
  left: .0625rem;
  top: 1.25rem;
  background-color: var(--BasicFontColor);
  -webkit-transform-origin: 100% 50%;
  -ms-transform-origin: 100% 50%;
  transform-origin: 100% 50%;
  transition: -webkit-transform .4s cubic-bezier(.23,1,.32,1);
  transition: transform .4s cubic-bezier(.23,1,.32,1);
  transition: transform .4s cubic-bezier(.23,1,.32,1),-webkit-transform .4s cubic-bezier(.23,1,.32,1);
}

.hover-item-a:focus:before, .hover-item-a:hover:before {
  -webkit-transform: scaleX(1);
  -ms-transform: scaleX(1);
  transform: scaleX(1);
  -webkit-transform-origin: 0 50%;
  -ms-transform-origin: 0 50%;
  transform-origin: 0 50%;
}
@media (max-width: 1199.98px) {
  .top-nav-item {
    margin-left: 0;
  }
}


</style>